module.exports = __webpack_public_path__ + "img/compressor.4e948280.svg";